import { registerPlugin } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';

export interface MuseFlowAudioPluginInterface {
  initialize(): Promise<void>;
  startPlayback(options: {
    bpm: number;
    timeSigNumerator: number;
    timeSigDenominator: number;
    countInMeasures: number;
    startMeasure: number;
    tickNoteType: number;
  }): Promise<{ startTime: number }>;
  pausePlayback(): Promise<void>;
  setBpm(options: { bpm: number }): Promise<void>;
  setMetronomeEnabled(options: { enabled: boolean }): Promise<void>;
  setDownbeatsEnabled(options: { enabled: boolean }): Promise<void>;
  setPianoEnabled(options: { enabled: boolean }): Promise<void>;
  getCurrentTime(): Promise<{ time: number }>;
  isAvailable(): Promise<{ available: boolean }>;
  addListener(
    eventName: 'tickEvent',
    handler: (data: { ticks: number; currentTime: number }) => void,
  ): Promise<PluginListenerHandle>;
  addListener(eventName: 'interrupted', handler: () => void): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'interruptionEnded',
    handler: (data: { shouldResume: boolean }) => void,
  ): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'nativeError',
    handler: (data: { message: string; code: string; context?: string }) => void,
  ): Promise<PluginListenerHandle>;
}

const MuseFlowAudio = registerPlugin<MuseFlowAudioPluginInterface>('MuseFlowAudio');

export default MuseFlowAudio;
